import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react/lib/Text';
import clsx from 'clsx';
import styles from './FinancialTableBodyHeader.style';

const FinancialTableBodyHeader = ({
  name,
  amount,
  purchasedUnits,
  returnCap,
  capLimit,
  actualReturns,
  returnsOverCap,
  returnsIncluded,
  className: classNameProp,
  isPerCap,
  ...other
}) => {
  const classNames = clsx(styles.root, classNameProp);

  return (
    <div className={classNames} {...other}>
      <div className={styles.name}>
        <Text as="p" variant="medium">
          {name} {!isPerCap && <span style={{ fontFamily: 'FabricMDL2Icons' }}>&#8595;</span>}
        </Text>
        <Text as="p" variant="medium" className={styles.purchasedUnits}>
          {purchasedUnits}
        </Text>
        <Text as="p" variant="medium" className={styles.returnCap}>
          {returnCap}
        </Text>
        <Text as="p" variant="medium" className={styles.capLimit}>
          {capLimit}
        </Text>
        <Text as="p" variant="medium" className={styles.actualReturns}>
          {actualReturns}
        </Text>
        <Text as="p" variant="medium" className={styles.returnsOverCap}>
          {returnsOverCap}
        </Text>
        <Text as="p" variant="medium" className={styles.returnsIncluded}>
          {returnsIncluded}
        </Text>
      </div>

      <div className={`${styles.amount} ${isPerCap ? styles.percapAmount : ''}`}>
        <Text as="p" variant="medium">
          {amount}
        </Text>
      </div>
    </div>
  );
};

FinancialTableBodyHeader.propTypes = {
  name: PropTypes.string,
  amount: PropTypes.string,
  className: PropTypes.string,
  isPerCap: PropTypes.bool,
  purchasedUnits: PropTypes.number,
  returnCap: PropTypes.number,
  capLimit: PropTypes.number,
  actualReturns: PropTypes.number,
  returnsOverCap: PropTypes.number,
  returnsIncluded: PropTypes.number,
};

FinancialTableBodyHeader.defaultProps = {
  name: '',
  amount: '',
  className: '',
  isPerCap: false,
  purchasedUnits: null,
  returnCap: null,
  capLimit: null,
  actualReturns: null,
  returnsOverCap: null,
  returnsIncluded: null,
};

export default FinancialTableBodyHeader;
